import { render, staticRenderFns } from "./GalleryForm.vue?vue&type=template&id=77a4876c"
import script from "./GalleryForm.vue?vue&type=script&lang=js"
export * from "./GalleryForm.vue?vue&type=script&lang=js"
import style0 from "./GalleryForm.vue?vue&type=style&index=0&id=77a4876c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports